// extracted by mini-css-extract-plugin
var _1 = "ImageLoadSwitch__fallbackImage--Xh2Qo";
var _2 = "ImageLoadSwitch__main--oalp2";
var _3 = "ImageLoadSwitch__mainImage--GP0pY";
export { _1 as "fallbackImage", _2 as "main", _3 as "mainImage" }
